import './index.scss';

export default {
    name: 'chj-button',
    props: {
        primary: Boolean,
        secondary: Boolean,
        small: Boolean,
        disabled: Boolean,
        text: String
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
